






import { defineComponent } from '@vue/composition-api';
import GroupCreateForm from './GroupCreateForm.vue';

export default defineComponent({
	components: {
		GroupCreateForm,
	},
	props: {
		parentGroupId: { type: String, required: false },
	},
	setup(props, { root }) {
		const nextPath = `/groups/${props.parentGroupId ? props.parentGroupId : ''}`;

		const handleSubmitSuccess = () => {
			root.$store.dispatch('groups/getGroups');
			root.$router.push(nextPath);
		};

		const handleCancel = async () => {
			root.$router.push(nextPath);
		};

		return {
			handleSubmitSuccess,
			handleCancel,
		};
	},
});
